/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require ./cell_renderers
//= require ./grid_options
//= require ./boq_utils
//= require ./bid_mapping

//= require blueimp-file-upload/js/jquery.fileupload.js

window.BidTree = {
  _newBidNodes: [],
  _editedBidNodes: [],
  _newBidModificationNodes: [],
  _editedBidModificationNodes: [],
  _deletedBidModificationNodes: [],
  _updateUnitPriceNodes: [],
  _unfilledIds: [],
  _colorEditable: true,

  _getRootNode() {
    const firstNode = this._gridOptions.api.getRowNode('0');
    return firstNode.parent;
  },

  _valueChangedHandler(event) {
    if (this._isModification(event.node) && (event.colDef.field === "code")) {
      event.node.code = event.oldValue;
      event.node.product_title = event.newValue;
    }
    this._updateGrandTotal();
    this._findOrPushNewOrModifiedBidOrModificationNode(event.node);
    return this._gridOptions.api.refreshClientSideRowModel('aggregate');
  },

  _updateInUnfilledCount(node, draw, removeElements) {
    if (draw == null) { draw = true; }
    if (removeElements == null) { removeElements = true; }
    if (this._isLeaf(node)) {
      if (this._hasModifications(node) || (node.data.modification_number > 0)) {
        this._updateUnfilledModification(node);
      } else if (this._isFilled(node)) {
        if (removeElements) { this._unfilledIds = _.without(this._unfilledIds, node.data.id); }
      } else {
        if (_.indexOf(this._unfilledIds, node.data.id) === -1) { this._unfilledIds.push(node.data.id); }
      }
      if (draw) { return this._drawUnfilledCount(); }
    }
  },

  _updateUnfilledModification(node) {
    if (this._hasModifications(node)) {
      if (_.indexOf(this._unfilledIds, node.data.id) === -1) { return this._unfilledIds.push(node.data.id); }
    } else if (this._isFilled(node)) {
      return this._unfilledIds = _.without(this._unfilledIds, node.data.original.id);
    } else if (!this._isFilled(node) && node.data.original && (_.indexOf(this._unfilledIds, node.data.original.id) === -1)) {
      return this._unfilledIds.push(node.data.original.id);
    }
  },

  _isLeaf(node) {
    return node.data['leaf?'] && !node.data.is_note && node.data.unit;
  },

  _isModificationLeaf(node) {
    return node.data['leaf?'] && !node.data.is_note && node.data.is_modification;
  },

  _isFilled(node) {
    return (node.data.price !== null) && (node.data.quantity !== null) &&
      (node.data.price.trim() !== '') && (node.data.price.trim() !== '');
  },

  _drawUnfilledCount() {
    return $('#unfilled').text(this._unfilledIds.length);
  },

  _uploadBidItemImage() {
    const _this = this;
    return $("#bid-item-photo-form").on('click', function () {
      return $(this).fileupload({
        add(e, data) {
          if (data.files[0].size > (5 * 1024 * 1024)) {
            return alert('Image is too big');
          } else if (!data.files[0].name.match(".+\.(?:jpe?g|png|gif|PNG|JP?G)")) {
            return alert('Incorrect format');
          } else {
            const node_id = $(this).find('#photo_node_id').val();
            const node = _this._gridOptions.api.getRowNode(node_id);
            node.data.uploading = true;
            _this._gridOptions.api.redrawRows();
            return data.submit();
          }
        },

        done(e, data) {
          const node = _this._gridOptions.api.getRowNode(data.result.node_id);
          node.data.uploading = false;
          node.data.photo_id = data.result.photo_id;
          node.data.photos = [{
            thumbnail_url: data.result.thumbnail_url,
            fullimage_url: data.result.fullimage_url,
            photo_id: data.result.photo_id
          }];
          _this._gridOptions.api.applyTransaction({ update: [node.data] });
          _this._gridOptions.api.redrawRows();
          return _this._findOrPushNewOrModifiedBidOrModificationNode(node);
        },
        fail(e, data) {
          return alert(JSON.parse(data.jqXHR.responseText).details);
        }
      });
    });
  },

  _updateGrandTotal() {
    const totalPrice = this._getRootNode().aggData.total_price;
    return $('#grand_total').html(totalPrice.toFixed(2));
  },

  _isNewBid(node) {
    return !node.data.bid_item_id;
  },

  _isNewModification(node) {
    return !Number(node.data.id);
  },

  _findOrPushNewOrModifiedBidOrModificationNode(node) {
    if (this._isModification(node)) {
      if (this._isNewModification(node)) {
        return this._findOrPushNewBidModification(node);
      } else {
        return this._findOrPushEditedBidModification(node);
      }
    } else {
      if (this._isNewBid(node)) {
        return this._findOrPushNewBidNode(node);
      } else {
        return this._findOrPushEditedBidNode(node);
      }
    }
  },

  _findOrPushNewBidModification(node) {
    const newModification = _.find(this._newBidModificationNodes, n => n.data.id === node.data.id);
    if (!newModification) { return this._newBidModificationNodes.push(node); }
  },

  _findOrPushEditedBidModification(node) {
    const editedModification = _.find(this._editedBidModificationNodes, n => n.data.id === node.data.id);
    if (!editedModification) { return this._editedBidModificationNodes.push(node); }
  },

  _findOrPushNewBidNode(node) {
    const newBidNode = _.find(this._newBidNodes, n => n.data.id === node.data.id);
    if (!newBidNode) { return this._newBidNodes.push(node); }
  },

  _findOrPushEditedBidNode(node) {
    const editedBidNode = _.find(this._editedBidNodes, n => n.data.id === node.data.id);
    if (!editedBidNode) { return this._editedBidNodes.push(node); }
  },

  _insertNote(row) {
    if (row.node.data.has_bidders_note) { return; }
    this._findOrPushNewOrModifiedBidOrModificationNode(row.node);
    const newRow = this._getEmptyRow();
    newRow.group = _.clone(row.node.data.group).concat([0]);
    newRow.is_note = true;
    newRow.bidders_note = true;
    row.node.data.has_bidders_note = true;
    const transactions = this._gridOptions.api.applyTransaction({ add: [newRow] });
    const newNode = transactions.add[0];
    this._expandNode(row.node);
    this._reSort();
    this._misleadSumAggregationForUnitPrice(row);
    this._gridOptions.api.redrawRows();
    this._gridOptions.api.ensureNodeVisible(newNode);
    return setTimeout((() => $(`#note-textarea-${newRow.id}`).focus()), 1);
  },

  _insertModification(row) {
    this._findOrPushNewOrModifiedBidOrModificationNode(row.node);
    const newRow = this._getEmptyRow();
    newRow.began_as_leaf = true;
    newRow.group = _.clone(row.node.data.group);
    newRow.is_modification = true;
    const lastElement = newRow.group[newRow.group.length - 1];
    newRow.modification_number = _.last(row.node.data.bid_modifications) + 1;
    newRow.group[newRow.group.length - 1] = `${lastElement}.${newRow.modification_number}`;
    newRow.original = row.node.data;
    row.node.data.bid_modifications.push(newRow.modification_number);
    const transactions = this._gridOptions.api.applyTransaction({ add: [newRow] });
    this._findOrPushNewOrModifiedBidOrModificationNode(transactions.add[0]);
    this._insertNote(row);
    this._reSort();
    this._misleadSumAggregationForUnitPrice({ node: row.node });
    this._gridOptions.api.redrawRows();
    return this._updateInUnfilledCount(row.node, true, false);
  },

  _insertImage(row, type) {
    $("#bid-item-photo-form input#photo_photoable_type").val(type);
    $("#bid-item-photo-form input#photo_node_id").val(row.node.id);
    return $("#bid-item-photo-form input[type='file']").trigger("click");
  },

  deleteSelectedRow(row) {
    const selected = row.node;
    if (!selected) { return; }

    this._newBidModificationNodes = _.without(this._newBidModificationNodes, selected);
    this._editedBidModificationNodes = _.without(this._editedBidModificationNodes, selected);
    this._deletedBidModificationNodes.push(selected);
    row.data.original.bid_modifications = _.without(row.data.original.bid_modifications, row.node.data.modification_number);
    const originalNode = this._gridOptions.api.getRowNode(row.data.original.node_id);
    if (!this._hasModifications(originalNode)) {
      originalNode.data.price = '';
    }
    this._gridOptions.api.applyTransaction({ remove: this._getRowsToDelete(selected) });
    this._misleadSumAggregationForUnitPrice({ node: originalNode });
    this._gridOptions.api.redrawRows();
    if (originalNode.data.bid_modifications.length > 1) {
      return this._gridOptions.api.forEachNode(node => {
        if (node.data.original && (node.data.original.id === originalNode.data.id)) { return this._updateInUnfilledCount(node, true, false); }
      });
    } else {
      return this._updateInUnfilledCount(originalNode, true, false);
    }
  },

  _showModalWithPhoto(modal, content, event) {
    event.preventDefault();
    const $modal = $(modal);
    const $content = $(content);
    const modalHeader = $content.find('.modal-header > h3');
    modalHeader.text(event.target.attributes.getNamedItem('data-title').value);
    const img = $content.find('img');
    img.attr('src', event.target.attributes.getNamedItem('data-fullimage-url').value);
    $modal.html($content.html());
    $modal.find($content).show();
    return $modal.foundation('reveal', 'open');
  },

  initializeTree(items, editorView, key, codeColumnsActive, modifications) {
    this._boqTree = false;
    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();
    this._rawData = items;
    this._setBidOptions(codeColumnsActive, modifications);
    this._editorMode = editorView ? true : false;

    const gridDiv = document.getElementById('bidTable');
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    $(document).on('click', ".boq-image", _.bind(this._showModalWithPhoto, this, '#modalContent', '#boqPhoto'));

    $(window).resize(_.bind(this._resize, this));
    this._gridOptions.api.forEachNode(node => {
      this._misleadSumAggregationForUnitPrice({ node });
      return this._updateInUnfilledCount(node, false, false);
    });
    this._drawUnfilledCount();
    this._uploadBidItemImage();

    $('.ag-header-cell[col-id="ag-Grid-AutoColumn"] .ag-header-cell-text')
      .prepend('<i id="expandAllButton" class="pti pt-minus-square"></i>');

    $('#expandAllButton').on('click', e => {
      return this._expandOrCollapseAll();
    });

    return $('#show_unfilled_bids').on('click', e => {
      this._colorEditable = e.target.checked;
      return $('.editable-cell').toggleClass('editable-color-disabled', !this._colorEditable);
    });
  }
};

if (window.BoqUtils) _.extend(BidTree, window.BoqUtils);
if (window.CellRenderers) _.extend(BidTree, window.CellRenderers);
if (window.GridOptions) _.extend(BidTree, window.GridOptions);
if (window.BidMapping) _.extend(BidTree, window.BidMapping);
